module.exports = __webpack_public_path__ + "54426acb27779ea944eaf5aea3548973.svg";